import SURVEY_API from './survey'
import { CRM_API, API_URL } from './crm'

const API = {
	...SURVEY_API,
	...CRM_API,
	...API_URL
}

export default API;